module.exports = __webpack_public_path__ + "img/book.7bf7d1cb.svg";